module.exports = __webpack_public_path__ + "assets/img/bitcoin-icon-2.0b768f0c.svg";